import {PaymentType} from "src/app/shared/enums/payment-type.enum";
import {AccountConnectedStatus} from "src/app/dashboard/bankAccounts/enums/accountConnectedStatus.enum";
import {BankAccountProvider} from 'src/app/dashboard/bankAccounts/enums/bankAccountProvider.enum';
import AccountType from "src/app/shared/enums/AccountType.enum";
export class ExternalClientBankAccountDto {
  public id: number;
  public tokenCreatedAt: Date;
  public nickname: string;
  public bankName: string;
  public holderFullName: string;
  public countryId: number;
  public countryCode: string;
  public organizationDetailsId: number;
  public clientDetailsId: number;
  public holdingId: number;
  public holdingName: string;
  public accountNumber: string;
  public usabaRoutingNumber: string;
  public fedWireRoutingNumber: string;
  public externalBankAccountConnectionDetailsId: string;
  public externalAccountId: string;
  public accessToken: string;
  public accessTokenId: string;
  public paymentType: PaymentType;
  public availableBalance: number;
  public currentBalance: number;
  public countryName: string;
  public companyDetailsId: string;
  public companyDetailsName: string;
  public accountType: AccountType;
  public verificationStatus?: number;
  public isRecent: boolean;
  connectedStatus: AccountConnectedStatus;
}

export class BankAccountTableRowDto {
  public accountProvider: BankAccountProvider;
  public id: number;
  public createdAtUTC: Date;
  public accountNickname: string;
  public accountType: AccountType;
  public accountNumber: string;
  public bankName: string;
  public entityId: string;
  public entityType: string;
  public entityName: string;
  public country: string;
  public currencySymbol: string;
  public connectedStatus: AccountConnectedStatus;
  public availableBalance: number;
  public currentBalance: number;
  public minutesFromLastBalanceFetching: number;
  public mask: string;
}

export class BankAccountDto {
  public id: number;
  public accountNickname: string;
  public bankName: string;
  public accountType: AccountType;
  public achRoutingNumber: string;
  public wireRoutingNumber: string;
  public accountHolderName: string;
  public accountHolderAddress: string;
  public accountNumber: string;
  public mask: string;
  public entityType: string;
  public entityName: string;
  public availableBalance: number;
  public currentBalance: number;
}

export class BalanceDto {
  public accountId: string;
  public accountName: string;
  public available: number;
  public current: number;
  public maxBalanceTime: Date;
}
